var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _g, _path151, _path152, _path153, _g2, _path154, _path155, _path156, _g3, _path157, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 330,
    viewBox: "0 0 323 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_7956)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.742 113.72C319.791 75.3853 293.92 43.1017 261.746 23.7773C230.375 5.02371 193.731 -2.96868 157.374 0.970428C107.466 6.5651 40.9982 38.4205 44.4648 97.0789C45.0951 107.697 48.1034 118.287 46.5276 128.792C43.7199 147.745 27.2748 161.218 16.3305 176.974C4.69864 193.815 -1.00271 214.025 0.143293 234.405C1.48984 257.041 13.2936 280.618 34.4087 289.096C55.5524 297.545 79.5038 289.153 102.338 289.981C139.325 291.351 171.212 316.87 207.684 323.206C234.901 327.802 262.835 321.522 285.44 305.68C295.84 298.344 305.036 288.782 309.821 276.993C321.911 247.364 303.747 213.654 308.532 181.998C311.827 160.247 323.544 141.237 323 118.715C322.943 117.031 322.885 115.347 322.742 113.663V113.72Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M322.742 113.72C319.791 75.3853 293.92 43.1017 261.746 23.7773C230.375 5.02371 193.731 -2.96868 157.374 0.970428C107.466 6.5651 40.9982 38.4205 44.4648 97.0789C45.0951 107.697 48.1034 118.287 46.5276 128.792C43.7199 147.745 27.2748 161.218 16.3305 176.974C4.69864 193.815 -1.00271 214.025 0.143293 234.405C1.48984 257.041 13.2936 280.618 34.4087 289.096C55.5524 297.545 79.5038 289.153 102.338 289.981C139.325 291.351 171.212 316.87 207.684 323.206C234.901 327.802 262.835 321.522 285.44 305.68C295.84 298.344 305.036 288.782 309.821 276.993C321.911 247.364 303.747 213.654 308.532 181.998C311.827 160.247 323.544 141.237 323 118.715C322.943 117.031 322.885 115.347 322.742 113.663V113.72Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.905 191.903L38.1617 289.81",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5001 271.056L31.8588 266.175",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2627 267.631C33.2627 266.118 32.5751 264.691 31.4004 263.72C30.2258 262.664 23.9228 260.038 23.3211 262.264C22.6908 264.634 29.1084 269.343 33.234 267.659L33.2627 267.631Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2627 267.631L27.3035 263.92",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6747 282.188L33.0334 277.307",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4373 278.763C34.4373 277.25 33.7497 275.823 32.5751 274.824C31.4004 273.768 25.0974 271.142 24.4958 273.368C23.8368 275.737 30.2831 280.447 34.4087 278.763H34.4373Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4372 278.763L28.478 275.052",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6638 243.911L29.0225 239.001",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4262 240.485C30.4262 238.972 29.7386 237.545 28.564 236.546C27.3893 235.49 21.0863 232.864 20.4847 235.09C19.8257 237.459 26.272 242.169 30.3976 240.485H30.4262Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4262 240.485L24.467 236.746",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8384 255.014L30.1971 250.133",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5723 251.646C31.5723 250.133 30.8847 248.706 29.7387 247.707C28.5354 246.65 22.261 244.024 21.6307 246.251C21.0577 248.591 27.4753 253.301 31.5723 251.646Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6009 251.617L25.613 247.907",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7729 225.813L27.1316 220.932",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5354 222.388C28.5354 220.875 27.8478 219.448 26.7018 218.449C25.4985 217.393 19.2242 214.767 18.5939 216.993C17.9922 219.362 24.4098 224.072 28.5354 222.388Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5353 222.388L22.5475 218.677",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8533 207.659L25.212 202.75",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6158 204.234C26.6158 202.721 25.9282 201.294 24.7822 200.295C23.5789 199.239 17.3046 196.613 16.7029 198.839C16.0726 201.208 22.4902 205.918 26.6158 204.234Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6158 204.234L20.6566 200.523",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7266 264.462L39.2505 258.725",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2191 260.437C37.9326 258.953 38.2764 257.412 39.2219 256.213C40.1673 254.928 45.7827 251.075 46.8141 253.101C47.9314 255.299 42.6026 261.237 38.2191 260.437Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1904 260.466L43.5766 255.328",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.661 235.176L36.185 229.438",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1249 231.151C34.8384 229.667 35.1822 228.125 36.1276 226.927C37.0731 225.642 42.6885 221.789 43.7199 223.815C44.8659 226.013 39.537 231.95 35.1249 231.151Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1249 231.151L40.5111 226.042",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3145 222.302L34.8384 216.565",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7783 218.278C33.4918 216.793 33.8356 215.252 34.7811 214.053C35.7265 212.769 41.3419 208.915 42.3733 210.942C43.4907 213.14 38.2191 219.077 33.7783 218.278Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7783 218.277L39.1359 213.168",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3376 203.435L32.8616 197.697",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8015 199.41C31.515 197.926 31.8588 196.384 32.8042 195.185C33.7497 193.901 39.3651 190.047 40.3965 192.074C41.5138 194.272 36.2136 200.209 31.8015 199.41Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8015 199.41L37.1877 194.272",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8191 191.389C27.5326 189.905 27.8764 188.363 28.8218 187.164C29.7673 185.88 35.3827 182.026 36.4141 184.053C37.5314 186.251 32.2312 192.16 27.8191 191.389Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8191 191.36L33.2053 186.251",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1343 191.589C26.6158 191.732 25.126 191.189 24.0373 190.162C22.8627 189.077 19.5679 183.14 21.7167 182.312C24.0373 181.427 29.3949 187.307 28.1343 191.589Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1343 191.589L23.579 185.708",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9506 205.375L44.7512 303.282",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0146 284.614L43.462 278.877",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5507 280.59C44.8372 279.105 44.4647 277.564 43.5479 276.365C42.6025 275.081 36.9871 271.227 35.9557 273.254C34.8383 275.452 40.1386 281.389 44.5507 280.59Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5508 280.59L39.4797 275.737",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8509 257.441L46.2983 251.703",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3871 253.416C47.6736 251.932 47.3012 250.39 46.3844 249.191C45.4389 247.907 39.8235 244.053 38.7921 246.08C37.6748 248.278 42.975 254.215 47.3871 253.416Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3871 253.416L42.2874 248.563",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6763 268.572L45.1523 262.835",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2124 264.576C46.4989 263.092 46.1551 261.551 45.2097 260.352C44.2642 259.067 38.6488 255.214 37.6174 257.241C36.5001 259.438 41.8003 265.376 46.2124 264.576Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2124 264.576L41.1414 259.695",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7133 239.343L48.1893 233.606",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.278 235.347C49.5645 233.863 49.2207 232.321 48.2753 231.122C47.3298 229.838 41.7144 225.984 40.683 228.011C39.537 230.209 44.8373 236.146 49.278 235.347Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2779 235.347L44.1782 230.495",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6041 221.189L50.0802 215.452",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1689 217.164C51.4554 215.68 51.0829 214.139 50.1661 212.94C49.2207 211.655 43.6053 207.802 42.5739 209.828C41.4565 212.026 46.7568 217.964 51.1689 217.164Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1689 217.165L46.0692 212.312",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6163 278.021L52.2576 273.111",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8538 274.567C50.8538 273.054 51.5414 271.627 52.6874 270.628C53.8907 269.572 60.165 266.946 60.7667 269.172C61.4256 271.541 54.9794 276.251 50.8538 274.567Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8538 274.567L57.1854 270.656",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6532 248.706L55.2945 243.825",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8906 245.28C53.8906 243.768 54.5782 242.34 55.7242 241.341C56.9275 240.285 63.2019 237.659 63.8035 239.886C64.4625 242.255 58.0162 246.965 53.8906 245.28Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8906 245.281L60.2223 241.37",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9998 235.832L56.6411 230.923",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2372 232.407C55.2372 230.894 55.9248 229.467 57.0994 228.468C58.3027 227.412 64.5771 224.786 65.1787 227.012C65.8377 229.381 59.3914 234.091 55.2658 232.407H55.2372Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2372 232.407L61.5688 228.497",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9766 216.965L58.6179 212.055",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M57.214 213.539C57.214 212.026 57.9016 210.599 59.0762 209.6C60.2509 208.544 66.5539 205.918 67.1555 208.144C67.8145 210.514 61.3682 215.223 57.2426 213.539H57.214Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M57.214 213.539L63.517 209.629",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9794 204.833C54.9794 203.321 55.667 201.922 56.8416 200.923C58.0163 199.867 64.3193 197.241 64.9209 199.467C65.5799 201.808 59.1336 206.518 55.008 204.833H54.9794Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9794 204.833L61.311 200.923",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2372 205.119C53.7474 204.919 52.4009 204.12 51.5414 202.864C50.5959 201.579 48.5904 195.071 50.8824 194.7C53.3177 194.301 57.3573 201.18 55.2086 205.09L55.2372 205.119Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2372 205.119L51.9998 198.439",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2615 165.528V289.324",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3761 270.713L39.2505 265.375",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 266.974C40.6544 265.461 40.1387 263.977 39.0786 262.864C37.9899 261.694 32.0307 258.411 31.1999 260.552C30.3117 262.864 36.2136 268.202 40.5111 266.974Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 266.974L34.953 262.664",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3761 247.45L39.2505 242.083",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 243.711C40.6544 242.198 40.1387 240.713 39.0786 239.6C37.9899 238.43 32.0307 235.147 31.1999 237.288C30.3117 239.6 36.2136 244.938 40.5111 243.711Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 243.711L34.953 239.4",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3761 220.133L39.2505 214.767",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 216.365C40.6544 214.852 40.1387 213.368 39.0786 212.283C37.9899 211.113 32.0307 207.83 31.1999 209.971C30.3117 212.312 36.2136 217.65 40.5111 216.394V216.365Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 216.394L34.953 212.083",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3761 201.95L39.2505 196.584",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 198.211C40.6544 196.698 40.1387 195.214 39.0786 194.129C37.9899 192.959 32.0307 189.676 31.1999 191.817C30.3117 194.129 36.2136 199.495 40.5111 198.239V198.211Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 198.211L34.953 193.901",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3761 183.682L39.2505 178.344",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 179.943C40.6544 178.43 40.1387 176.946 39.0786 175.833C37.9899 174.662 32.0307 171.437 31.1999 173.52C30.3117 175.833 36.2136 181.17 40.5111 179.943Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5111 179.943L34.953 175.632",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2902 277.821L47.3871 272.455",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 274.082C46.0119 272.598 46.5563 271.113 47.5877 270C48.6764 268.83 54.6356 265.604 55.4664 267.688C56.3546 270 50.4527 275.309 46.1552 274.082Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 274.081L52.0284 269.543",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2902 240.799L47.3871 235.461",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1551 237.06C46.0118 235.547 46.5275 234.062 47.5876 232.978C48.6763 231.807 54.6355 228.525 55.4663 230.666C56.3545 232.978 50.4526 238.315 46.1551 237.088V237.06Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 237.06L52.0284 232.521",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2902 222.559L47.3871 217.193",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1551 218.82C46.0118 217.307 46.5275 215.823 47.5876 214.71C48.6763 213.539 54.6355 210.257 55.4663 212.398C56.3545 214.71 50.4526 220.047 46.1551 218.82Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 218.82L52.0284 214.253",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2902 198.411L47.3871 193.073",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1551 194.672C46.0118 193.159 46.5275 191.674 47.5876 190.561C48.6763 189.391 54.6355 186.108 55.4663 188.249C56.3545 190.561 50.4526 195.899 46.1551 194.672Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 194.671L52.0284 190.133",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2902 179.429L47.3871 174.091",
    stroke: "#263238",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1551 175.69C46.0118 174.177 46.5275 172.692 47.5876 171.579C48.6763 170.409 54.6355 167.126 55.4663 169.267C56.3545 171.579 50.4526 176.917 46.1551 175.69Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1552 175.689L52.0284 171.151",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0323 167.269C42.889 165.756 43.4047 164.272 44.4648 163.159C45.5535 161.988 51.5127 158.763 52.3435 160.847C53.2317 163.159 47.3298 168.496 43.0323 167.269Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0322 167.269L48.9341 162.73",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3188 167.526C41.8004 167.526 40.3679 166.841 39.3938 165.671C38.3337 164.472 35.6979 158.221 37.9326 157.621C40.3392 156.993 45.0378 163.387 43.3475 167.526H43.3188Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3187 167.526L39.3937 161.218",
    stroke: "#263238",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3898 321.437H35.2108L33.5778 288.325H50.0229L48.3898 321.437Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 187.377C122.585 187.377 125.153 194.091 125.62 194.889C126.087 195.687 119.549 198.412 118.081 199.044C116.613 199.675 114.245 191.532 114.245 191.532L122.585 187.377Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M103.236 120.007C103.236 120.007 108.607 120.439 110.308 127.286C112.009 134.133 114.378 151.881 114.378 155.936C114.378 159.991 118.882 176.044 121.25 179.235C123.619 182.426 124.486 187.777 122.551 189.272C120.616 190.768 117.18 195.255 112.677 190.967C108.173 186.68 102.602 172.355 102.168 168.067C101.735 163.78 103.669 156.302 103.87 153.31C104.07 150.319 103.67 132.139 101.935 128.084C100.2 124.029 99.3661 121.237 99.3661 121.237C99.3661 121.237 100.233 119.542 103.236 119.941V120.007Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M121.45 205.126C121.45 205.126 123.051 208.15 122.751 208.948C122.451 209.746 120.816 209.114 120.183 209.28C119.549 209.446 119.082 211.507 120.183 212.139C121.283 212.77 122.117 214.864 123.719 214.365C125.32 213.867 125.954 209.878 125.954 207.186C125.954 204.494 122.918 202.832 121.484 205.092L121.45 205.126Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.947 197.914C117.947 197.914 116.98 204.627 117.314 206.057C117.681 207.785 117.947 209.546 118.114 211.341C118.114 211.973 118.114 213.435 120.183 212.139C122.251 210.843 120.516 207.851 120.816 206.721C121.117 205.591 122.885 205.591 123.552 206.555C124.286 207.851 124.553 209.347 124.353 210.843C124.186 212.604 121.617 214.665 122.284 215.33C122.951 215.994 124.219 216.127 125.654 214.366C127.088 212.604 127.889 208.782 127.588 206.389C127.288 203.996 126.621 199.376 125.987 197.614C125.587 196.551 125.12 195.554 124.553 194.59L117.981 197.98L117.947 197.914Z",
    fill: "#E8D0B4",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9523 103.787C81.9523 103.787 83.3867 114.722 81.8188 116.882C80.2509 119.043 74.1794 119.741 69.5424 121.901C64.9054 124.061 65.3725 127.086 65.3725 131.108C65.3725 135.129 73.4455 158.129 73.0119 162.317C72.5782 166.505 61.7696 178.27 59.8681 190.069C57.9666 201.868 68.9753 235.936 70.4098 241.387C71.8443 246.838 73.1453 250.294 71.5774 255.479C70.0095 260.664 67.274 264.553 66.9737 273.593C66.6735 282.634 73.6123 306.797 74.046 309.123C74.4797 311.45 71.3105 318.596 70.4431 322.351C69.5758 326.107 72.9118 327.669 75.5806 327.536C78.2493 327.403 83.0865 326.373 83.0865 324.512C83.0865 322.65 81.4852 314.308 81.4852 311.117C81.4852 307.927 81.9189 302.908 81.9189 300.781C81.9189 298.654 84.2207 277.914 84.7879 273.593C85.355 269.272 87.023 262.426 87.023 262.426C87.023 262.426 86.5893 284.428 86.0222 290.477C85.4551 296.526 83.7203 317.067 84.5877 319.26C85.4551 321.454 89.0579 320.955 92.961 321.687C96.8641 322.418 95.6965 323.847 100.467 324.711C105.237 325.575 111.442 325.874 110.708 323.581C109.975 321.288 104.937 318.263 102.335 314.674C99.733 311.084 96.4304 308.193 96.2636 307.195C96.1635 305.367 96.2636 303.539 96.5639 301.745C96.8641 299.717 100.867 290.943 102.335 284.761C103.803 278.579 103.336 277.15 103.77 267.644C104.203 258.138 101.735 253.252 103.336 247.203C104.937 241.154 110.375 221.445 111.909 210.277C113.444 199.11 114.245 188.773 113.244 183.788C111.309 174.382 106.438 168.133 105.571 164.544C104.704 160.954 108.74 154.606 110.608 145.566C112.476 136.525 109.04 128.748 107.172 124.427C105.304 120.106 99.2326 118.245 98.2319 117.813C97.2311 117.381 96.3637 112.628 96.1969 109.604C96.0301 106.579 96.0635 105.017 96.0635 105.017L81.9189 103.82L81.9523 103.787Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4097 322.418C71.277 318.663 74.4462 311.483 74.0125 309.19C73.8458 308.193 72.478 303.241 70.9768 297.225C74.6797 298.322 78.6496 298.156 82.2858 296.793C82.0856 298.887 81.9522 300.382 81.9522 300.914C81.9522 303.075 81.5185 308.093 81.5185 311.251C81.5185 314.408 83.1198 322.751 83.1198 324.645C83.1198 326.54 78.3493 327.503 75.6138 327.67C72.8783 327.836 69.5423 326.207 70.4097 322.485V322.418ZM110.675 323.548C109.941 321.255 104.904 318.23 102.302 314.641C99.6996 311.051 96.397 308.16 96.2302 307.163C96.1301 305.335 96.2302 303.507 96.5304 301.712C96.9307 300.183 97.4311 298.687 98.065 297.225C93.9617 298.787 89.3581 298.521 85.4883 296.46C84.7878 304.936 83.9204 317.566 84.5876 319.228C85.455 321.388 89.0578 320.923 92.9609 321.654C96.864 322.385 95.6964 323.814 100.467 324.678C105.237 325.543 111.442 325.842 110.708 323.548H110.675Z",
    fill: "#E8D0B4",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M110.675 323.548C109.941 321.255 104.904 318.23 102.302 314.641C99.6997 311.051 96.3971 308.16 96.2303 307.163C96.2303 307.163 93.1278 308.226 92.6941 309.722C92.3939 310.752 92.0269 311.749 91.6266 312.713C89.5917 313.079 87.5233 312.846 85.6218 312.082C85.1882 311.882 84.7545 311.683 84.4543 311.517C84.2875 315.405 84.2541 318.496 84.5543 319.227C85.4217 321.388 89.0245 320.923 92.9276 321.654C96.8307 322.385 95.6631 323.814 100.434 324.678C105.204 325.542 111.409 325.875 110.675 323.548Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M110.675 323.548C103.803 324.711 97.6647 321.62 93.895 320.058C90.8259 318.961 87.59 318.23 84.3541 317.897C84.3541 318.363 84.4208 318.795 84.5543 319.227C85.4216 321.387 89.0245 320.922 92.9276 321.653C96.8307 322.384 95.6631 323.814 100.434 324.678C105.204 325.542 111.376 325.841 110.675 323.548Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5186 310.719C80.2176 309.988 78.7164 309.622 77.2152 309.722C76.1143 309.688 75.0135 309.888 73.9793 310.32C73.6124 313.311 71.1437 319.161 70.3765 322.418C69.5091 326.141 72.8451 327.736 75.5139 327.603C78.1827 327.47 83.0198 326.44 83.0198 324.579C83.0198 322.717 81.4185 314.375 81.4185 311.184L81.4853 310.719H81.5186Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1198 324.545C83.1198 324.08 83.0197 323.249 82.8862 322.185C82.0189 323.648 80.3175 325.443 76.7814 325.609C70.7766 325.841 70.7766 321.321 70.7766 321.321C70.6766 321.687 70.5765 322.053 70.5098 322.385C69.6424 326.107 72.9784 327.703 75.6472 327.57C78.3159 327.437 83.1198 326.407 83.1198 324.545Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M105.638 164.477C104.77 160.887 108.807 154.539 110.675 145.499C112.543 136.458 109.107 128.681 107.239 124.36C105.371 120.039 99.2994 118.178 98.2986 117.746C97.2978 117.314 96.4305 112.561 96.2637 109.537C96.0969 106.512 96.1302 104.95 96.1302 104.95L81.9857 103.82C81.9857 103.82 83.4202 114.755 81.8522 116.915C80.2843 119.075 74.2129 119.773 69.5758 121.934C64.9388 124.094 65.4059 127.119 65.4059 131.14C65.4059 135.162 73.4789 158.162 73.0453 162.35C72.6116 166.537 61.803 178.303 59.9015 190.102C59.8348 190.435 59.8014 190.767 59.7681 191.132C69.3423 194.356 79.3836 196.118 89.4916 196.384C102.068 196.783 109.708 193.027 113.778 190.002C113.811 187.909 113.677 185.815 113.311 183.787C111.342 174.381 106.472 168.133 105.604 164.543L105.638 164.477Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2652 117.746C97.2644 117.314 96.397 112.561 96.2302 109.537C96.0634 106.512 96.0968 104.95 96.0968 104.95L81.9522 103.82C81.9522 103.82 83.3867 114.755 81.8188 116.915C80.8514 118.211 78.2159 119.009 75.2803 119.906C75.9475 120.771 80.8514 126.52 91.4931 124.659C95.4963 124.061 99.1992 122.233 102.102 119.441C100.867 118.81 99.5995 118.245 98.2652 117.779V117.746Z",
    fill: "#E8D0B4",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2636 109.537C96.1302 106.513 96.1302 104.95 96.1302 104.95L87.1898 104.219L86.4225 105.914C86.4225 105.914 90.7259 110.401 96.4638 111.764C96.3637 110.966 96.297 110.202 96.2636 109.537Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2214 105.848L85.0212 109.172C85.0212 109.172 81.2182 112.163 70.3763 105.05C59.5344 97.9376 61.5026 74.7716 70.3763 67.2934C79.25 59.8151 92.3937 61.3773 96.13 63.4379C99.8663 65.4986 102.669 64.1027 104.136 69.9191C105.604 75.7355 103.036 78.4609 103.036 78.4609C103.036 78.4609 100.634 75.7687 99.5995 75.237C98.5653 74.7052 94.4621 75.4031 92.7941 77.6965C91.1261 79.9898 88.4573 95.611 87.9903 98.8017C87.4565 101.261 86.5224 103.621 85.2214 105.815V105.848Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9317 71.0827C97.9317 71.0827 102.435 73.509 104.937 81.8181C107.439 90.1273 107.506 99.4336 106.739 101.86C105.971 104.186 104.137 105.981 101.801 106.712C98.7657 107.543 95.5631 107.743 92.4273 107.377C89.8586 106.912 85.1882 105.848 85.1882 105.848C85.1882 105.848 87.39 70.85 97.9317 71.0827Z",
    fill: "#E8D0B4",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M100.667 81.353C100.667 81.353 99.7999 84.1449 100.667 86.2388C101.535 88.3327 104.871 89.1304 104.437 90.0278C104.003 90.9252 100.967 92.9526 100.967 92.9526",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M102.902 96.2422C102.902 96.2422 101.635 97.8376 96.6639 96.6743",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9959 87.9998C95.2294 88.6978 95.096 89.3625 94.6623 89.4954C94.2286 89.6284 93.7282 89.1631 93.5281 88.4651C93.3279 87.7671 93.428 87.1024 93.8617 86.9695C94.2953 86.8365 94.7957 87.3018 94.9959 87.9998Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M103.369 83.8455C103.603 84.5435 103.469 85.2082 103.036 85.3411C102.602 85.4741 102.102 85.0088 101.901 84.3108C101.701 83.6128 101.801 82.9481 102.235 82.8152C102.669 82.6822 103.136 83.1475 103.369 83.8455Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0587 86.0052C90.0587 86.0052 90.5258 83.8116 93.5949 82.7812",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M100.434 80.2225C100.434 80.2225 102.635 78.7933 104.003 80.6878",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M130.491 128.582L122.718 128.749C122.051 128.749 121.517 128.25 121.517 127.585C121.517 127.552 121.517 127.486 121.517 127.452L123.785 107.178C123.852 106.58 124.319 106.148 124.92 106.148L132.726 105.981C133.36 105.981 133.893 106.48 133.927 107.111C133.927 107.178 133.927 107.211 133.927 107.278L131.692 127.552C131.625 128.15 131.125 128.582 130.557 128.582H130.491Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M114.144 131.839C114.144 131.839 116.013 124.361 116.313 122.5C116.613 120.638 117.314 119.342 118.481 119.209C119.649 119.076 120.95 118.777 120.95 118.777C120.95 118.777 127.588 115.354 129.89 115.055C132.192 114.755 133.059 115.055 132.359 115.919C131.658 116.783 127.755 118.943 126.454 119.641C125.153 120.339 123.419 121.336 123.419 122.101C123.419 122.865 125.72 122.533 126.287 122.101C126.855 121.669 131.058 119.242 132.626 119.375C134.194 119.508 132.893 121.835 131.325 122.533C129.757 123.231 125.253 126.987 125.253 126.987C127.088 126.222 128.856 125.358 130.591 124.427C131.892 123.563 132.025 122.566 133.059 122.832C134.094 123.098 133.793 125.291 132.326 126.554C130.858 127.817 129.59 130.443 127.855 131.573C126.121 132.703 117.48 138.054 117.48 138.054L113.01 132.437L114.178 131.872L114.144 131.839Z",
    fill: "#E8D0B4",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M131.625 127.286C129.824 128.815 127.822 130.011 125.62 130.842",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M120.149 119.076C119.082 119.708 118.215 120.672 117.714 121.802",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M113.577 130.41L120.516 138.753L114.011 142.641L108.507 134.997L113.577 130.41Z",
    fill: "#009476",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5416 122.633C68.5416 122.633 62.6035 123.929 62.4701 131.54C62.3366 139.151 73.2786 165.907 74.7465 167.469C76.2143 169.031 80.2175 167.901 81.5185 167.17C82.8195 166.439 109.674 149.621 112.243 147.328C112.243 147.328 114.545 145.167 114.712 143.572C114.878 141.977 110.675 136.692 110.675 136.692C110.675 136.692 107.806 134.133 105.638 133.967C103.469 133.8 82.8195 150.219 82.8195 150.219C82.8195 150.219 76.0475 130.211 75.0134 129.347",
    fill: "#009476"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5416 122.633C68.5416 122.633 62.6035 123.929 62.4701 131.54C62.3366 139.151 73.2786 165.907 74.7465 167.469C76.2143 169.031 80.2175 167.901 81.5185 167.17C82.8195 166.439 109.674 149.621 112.243 147.328C112.243 147.328 114.545 145.167 114.712 143.572C114.878 141.977 110.675 136.692 110.675 136.692C110.675 136.692 107.806 134.133 105.638 133.967C103.469 133.8 82.8195 150.219 82.8195 150.219C82.8195 150.219 76.0475 130.211 75.0134 129.347",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M151.635 57.8267H300.365C305.397 57.8267 309.495 61.9088 309.495 66.9232V287.811H142.505V66.9232C142.505 61.9088 146.602 57.8267 151.635 57.8267Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M300.365 57.8267H189.608V83.4769H309.462V66.891C309.462 61.8767 305.365 57.8267 300.332 57.8267H300.365Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M300.365 57.8267H151.635C146.602 57.8267 142.505 61.9088 142.505 66.9232V73.5447H309.495V66.9232C309.495 61.9088 305.43 57.8267 300.365 57.8267Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M287.04 68.4017C288.412 68.4017 289.524 67.2936 289.524 65.9267C289.524 64.5598 288.412 63.4517 287.04 63.4517C285.668 63.4517 284.556 64.5598 284.556 65.9267C284.556 67.2936 285.668 68.4017 287.04 68.4017Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M294.815 68.4017C296.187 68.4017 297.3 67.2936 297.3 65.9267C297.3 64.5598 296.187 63.4517 294.815 63.4517C293.444 63.4517 292.331 64.5598 292.331 65.9267C292.331 67.2936 293.444 68.4017 294.815 68.4017Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M302.558 68.4017C303.93 68.4017 305.043 67.2936 305.043 65.9267C305.043 64.5598 303.93 63.4517 302.558 63.4517C301.186 63.4517 300.074 64.5598 300.074 65.9267C300.074 67.2936 301.186 68.4017 302.558 68.4017Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M282.588 109.384H236.485V114.752H282.588V109.384Z",
    fill: "#CCCCCC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 120.988H236.485V126.356H299.171V120.988Z",
    fill: "#CCCCCC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 132.56H236.485V137.927H299.171V132.56Z",
    fill: "#CCCCCC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M282.588 171.035H236.485V176.403H282.588V171.035Z",
    fill: "#CCCCCC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 182.607H236.485V187.975H299.171V182.607Z",
    fill: "#CCCCCC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 194.21H236.485V199.578H299.171V194.21Z",
    fill: "#CCCCCC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M282.588 232.653H236.485V238.021H282.588V232.653Z",
    fill: "#CCCCCC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 244.257H236.485V249.625H299.171V244.257Z",
    fill: "#CCCCCC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M299.171 255.829H236.485V261.197H299.171V255.829Z",
    fill: "#CCCCCC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 272.8C199.428 272.8 211.546 260.726 211.546 245.832C211.546 230.938 199.428 218.864 184.478 218.864C169.529 218.864 157.41 230.938 157.41 245.832C157.41 260.726 169.529 272.8 184.478 272.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 218,
    width: 55,
    height: 55
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 272.8C199.428 272.8 211.546 260.726 211.546 245.832C211.546 230.938 199.428 218.864 184.478 218.864C169.529 218.864 157.41 230.938 157.41 245.832C157.41 260.726 169.529 272.8 184.478 272.8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.412 291.958C170.218 292.793 168.992 293.629 167.573 294.015C166.153 294.401 164.54 294.272 163.411 293.372C161.959 292.183 161.701 290.093 161.862 288.229C162.185 284.436 163.798 280.675 163.056 276.947C162.508 274.215 160.733 271.868 158.281 270.55C155.797 269.265 152.893 269.168 150.312 270.261C148.732 270.936 147.247 272.254 147.086 273.925C147.602 275.5 149.958 276.818 151.538 277.365C153.119 277.911 154.861 278.522 155.636 279.968C156.313 281.222 156.055 282.765 155.894 284.211C155.636 286.622 155.732 289.097 156.184 291.476C156.507 293.276 157.087 295.076 158.281 296.458C160.185 298.611 163.314 299.254 166.185 298.933C169.057 298.611 171.735 297.518 174.477 296.715L171.444 291.926L171.412 291.958Z",
    fill: "#009476",
    stroke: "#1A2E35",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83 278.297C162.959 277.975 163.056 277.654 163.121 277.332C163.121 277.204 163.088 277.075 163.056 276.915C162.508 274.182 160.733 271.836 158.281 270.518C155.797 269.232 152.893 269.136 150.312 270.229C148.732 270.904 147.247 272.222 147.086 273.893C147.602 275.468 149.958 276.786 151.538 277.332C153.119 277.879 154.861 278.49 155.636 279.936C156.087 280.804 156.12 281.768 156.055 282.765C156.345 282.797 156.636 282.829 156.926 282.765C159.539 282.604 161.959 280.707 162.895 278.232L162.83 278.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.187 258.272C180.187 258.625 178.122 263.607 173.025 267.625C167.928 271.643 163.701 276.4 163.798 282.668C163.895 288.936 167.766 295.815 167.766 295.815L171.767 298.965L186.543 299.094C186.543 299.094 193.35 297.454 194.221 291.893C195.092 286.333 193.35 283.633 193.35 283.633L193.608 278.04C193.608 278.04 197.673 270.583 197.932 268.172C198.19 265.761 195.964 257.018 195.964 257.018L180.187 258.304V258.272Z",
    fill: "#009476",
    stroke: "#1A2E35",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.124 238.214C190.124 238.214 183.704 239.21 182.317 239.757C180.929 240.303 175.316 243.196 174.445 245.96C174.445 245.96 173.993 249.078 175.38 252.903C175.896 254.285 179.961 259.011 180.929 259.557C181.897 260.103 196.093 257.596 196.093 257.596C196.931 256.439 199.416 252.421 199.383 249.432C199.383 245.671 197.996 241.428 197.996 241.428L190.092 238.214H190.124Z",
    fill: "#009476",
    stroke: "#1A2E35",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.092 231.721C195.092 231.721 193.253 231.721 191.963 234.646C191.156 236.446 190.253 238.15 189.221 239.821L198.093 241.878C198.093 241.878 197.609 237.089 197.093 235.45C196.577 233.811 196.093 231.914 195.092 231.753V231.721Z",
    fill: "#009476",
    stroke: "#1A2E35",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35 249.882C189.479 248.757 186.188 249.271 183.381 250.525C181.833 251.232 180.284 252.261 179.574 253.804C178.445 256.375 179.994 259.396 182.155 261.164C184.317 262.932 187.027 263.897 189.382 265.439C191.737 266.982 193.802 269.489 193.512 272.286L193.641 278.007C193.866 277.59 197.673 270.486 197.932 268.139C198.157 266.082 196.544 259.429 196.093 257.5C196.286 257.243 196.609 256.696 196.996 256.214C197.028 253.45 194.963 250.911 192.318 249.882H192.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.382 248.79C189.447 248.532 189.318 248.307 189.059 248.211H188.995C188.253 248.115 187.511 248.211 186.866 248.5C186.704 248.532 186.575 248.661 186.511 248.79C186.511 248.95 186.511 249.111 186.64 249.24C187.221 249.915 188.221 250.011 188.898 249.432C189.092 249.272 189.221 249.111 189.318 248.886C189.318 248.854 189.35 248.822 189.35 248.757L189.382 248.79Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.608 251.971C189.414 252.228 189.156 252.389 188.834 252.453C188.543 252.55 188.221 252.518 187.93 252.389C188.221 252.389 188.511 252.389 188.801 252.325C189.092 252.228 189.35 252.132 189.608 251.971Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.606 246.539C174.606 246.539 171.573 236.093 172.864 235.193C174.154 234.293 175.348 235.353 175.348 235.353L182.026 240.4L174.606 246.507V246.539Z",
    fill: "#009476",
    stroke: "#1A2E35",
    strokeWidth: 0.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.445 244.418C176.574 242.843 178.09 241.557 179.865 240.721L175.283 237.121C175.09 236.928 174.832 236.832 174.574 236.832C174.315 236.928 174.154 237.121 174.09 237.378C173.928 238.021 174.09 239.05 174.219 239.693C174.574 241.396 174.993 243.004 175.445 244.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.544 240.496C194.899 239.564 193.092 239.05 191.189 238.985C192.06 237.346 192.931 235.675 193.802 234.035C193.931 233.81 194.06 233.553 194.318 233.489C194.576 233.489 194.802 233.585 194.931 233.778C195.351 234.26 195.609 235.224 195.738 235.867C196.093 237.507 196.383 239.082 196.544 240.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.415 255.411C197.415 255.411 197.383 255.508 197.351 255.572C197.286 255.7 197.222 255.829 197.157 256.022C196.899 256.568 196.577 257.05 196.189 257.533C195.609 258.208 194.931 258.786 194.157 259.204C193.931 259.333 193.705 259.429 193.447 259.525C193.189 259.622 192.931 259.718 192.673 259.783C192.415 259.847 192.124 259.911 191.866 259.943C191.576 259.975 191.286 260.008 191.027 260.008C190.511 260.008 190.027 260.008 189.511 259.879V259.75C190.253 260.04 190.898 260.49 191.415 261.036L191.511 261.133H191.382C190.285 261.133 189.188 260.972 188.156 260.618C187.866 260.522 187.575 260.425 187.285 260.297C187.188 260.265 187.124 260.2 187.059 260.2C187.059 260.2 186.995 260.2 186.995 260.168C187.091 260.168 187.188 260.233 187.285 260.297C187.479 260.361 187.769 260.49 188.156 260.586C189.188 260.908 190.285 261.068 191.35 261.036V261.133C190.769 260.586 190.156 260.168 189.479 259.879L188.898 259.654L189.511 259.783C189.995 259.879 190.511 259.911 190.995 259.879C191.286 259.879 191.544 259.847 191.834 259.815C192.092 259.783 192.382 259.718 192.641 259.654C192.899 259.59 193.157 259.525 193.383 259.429C193.608 259.333 193.867 259.236 194.06 259.108C194.834 258.69 195.512 258.143 196.093 257.5C196.48 257.05 196.802 256.568 197.06 256.054C197.157 255.893 197.222 255.733 197.286 255.636C197.286 255.572 197.351 255.54 197.383 255.475L197.415 255.411Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.544 271.515C193.544 271.515 193.576 271.707 193.576 271.804C193.576 271.997 193.608 272.286 193.641 272.608C193.673 273.283 193.705 274.247 193.738 275.308C193.77 276.368 193.738 277.3 193.738 278.008C193.738 278.361 193.738 278.618 193.705 278.811C193.705 278.908 193.705 279.004 193.673 279.1C193.673 279.004 193.673 278.908 193.673 278.811V278.008C193.673 277.3 193.673 276.368 193.673 275.308C193.673 274.247 193.641 273.347 193.608 272.608C193.608 272.286 193.608 272.029 193.608 271.804C193.608 271.707 193.608 271.611 193.608 271.515H193.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.736 248.179C183.736 248.822 183.22 249.336 182.575 249.336C181.929 249.336 181.413 248.822 181.413 248.179C181.413 247.536 181.929 247.021 182.575 247.021C183.22 247.021 183.736 247.536 183.736 248.179Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.576 246.411C193.576 247.053 193.06 247.568 192.415 247.568C191.769 247.568 191.253 247.053 191.253 246.411C191.253 245.768 191.769 245.253 192.415 245.253C193.06 245.253 193.576 245.768 193.576 246.411Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64 249.079C191.64 249.079 191.64 249.336 191.64 249.464C191.576 249.818 191.447 250.171 191.285 250.493C191.221 250.589 191.156 250.686 191.06 250.782C190.963 250.879 190.834 250.943 190.737 251.007C190.447 251.136 190.156 251.168 189.866 251.072C189.705 251.039 189.576 250.943 189.446 250.879C189.317 250.782 189.188 250.686 189.059 250.589C188.801 250.364 188.543 250.107 188.35 249.85H188.479V249.882C188.317 250.557 187.866 251.104 187.253 251.457C186.995 251.586 186.672 251.65 186.382 251.618C186.123 251.618 185.865 251.489 185.672 251.361C185.349 251.168 185.091 250.879 184.93 250.557C184.898 250.461 184.833 250.364 184.801 250.3C184.801 250.236 184.768 250.204 184.801 250.204C184.833 250.204 184.865 250.332 184.994 250.557C185.188 250.879 185.446 251.136 185.736 251.329C185.93 251.457 186.188 251.554 186.414 251.554C186.704 251.554 186.962 251.554 187.22 251.393C187.801 251.071 188.188 250.525 188.35 249.882V249.818L188.414 249.689L188.479 249.786C188.672 250.043 188.93 250.3 189.188 250.493C189.317 250.589 189.446 250.686 189.576 250.782C189.705 250.879 189.834 250.943 189.963 250.975C190.479 251.136 191.027 250.943 191.285 250.493C191.479 250.204 191.608 249.85 191.673 249.496C191.737 249.239 191.737 249.079 191.737 249.079H191.64Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.543 238.825L184.897 239.147C185.027 239.822 185.252 240.465 185.607 241.075C185.736 241.268 185.93 241.493 186.156 241.493C186.285 241.493 186.414 241.397 186.511 241.268C186.575 241.14 186.64 241.011 186.64 240.85C186.769 240.175 186.704 239.5 186.543 238.825Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.577 250.814C201.577 250.814 201.351 250.782 201.254 250.75L200.383 250.525C199.641 250.332 198.609 250.107 197.48 249.947C196.351 249.786 195.286 249.657 194.512 249.593L193.608 249.529C193.608 249.529 193.382 249.529 193.286 249.497C193.382 249.497 193.511 249.497 193.608 249.497C193.834 249.497 194.124 249.497 194.512 249.497C196.512 249.593 198.48 249.914 200.416 250.429C200.77 250.525 201.093 250.622 201.287 250.686C201.383 250.686 201.513 250.75 201.609 250.814H201.577Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.448 248.725C202.448 248.725 202.222 248.725 202.093 248.725H201.158C200.351 248.725 199.254 248.725 198.061 248.725C196.867 248.725 195.738 248.821 194.963 248.853L194.028 248.918C194.028 248.918 193.802 248.918 193.673 248.918C193.77 248.886 193.899 248.853 194.028 248.853C194.254 248.853 194.576 248.789 194.963 248.757C195.77 248.693 196.867 248.596 198.061 248.564C199.254 248.532 200.384 248.564 201.19 248.564C201.577 248.564 201.9 248.596 202.126 248.628C202.255 248.628 202.352 248.628 202.481 248.661L202.448 248.725Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.351 253.804C202.351 253.804 202.126 253.707 202.029 253.643C201.835 253.514 201.513 253.354 201.126 253.129C200.158 252.582 199.125 252.1 198.093 251.682C197.06 251.264 195.996 250.879 194.931 250.589C194.512 250.461 194.189 250.364 193.963 250.3C193.834 250.3 193.737 250.236 193.608 250.204C193.737 250.204 193.866 250.204 193.963 250.268C194.189 250.3 194.544 250.396 194.963 250.493C197.157 251.071 199.254 251.939 201.19 253.064C201.577 253.289 201.868 253.482 202.061 253.611C202.158 253.675 202.287 253.739 202.384 253.836L202.351 253.804Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.058 252.325C182.058 252.325 181.865 252.454 181.768 252.518L180.994 253C180.316 253.418 179.413 253.965 178.413 254.64C177.413 255.315 176.542 255.957 175.929 256.407L175.187 256.986C175.187 256.986 174.993 257.115 174.896 257.179C174.961 257.082 175.058 257.018 175.154 256.954C175.316 256.825 175.574 256.6 175.864 256.375C176.477 255.893 177.348 255.25 178.316 254.575C179.284 253.9 180.22 253.354 180.929 252.968C181.284 252.775 181.542 252.614 181.736 252.518C181.833 252.454 181.929 252.422 182.026 252.357L182.058 252.325Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.897 251.425C181.897 251.425 181.833 251.457 181.8 251.49L181.478 251.65L180.284 252.197C179.284 252.647 177.897 253.29 176.38 254.029C174.864 254.768 173.509 255.443 172.541 255.957L171.38 256.568L171.057 256.729C171.057 256.729 170.993 256.761 170.928 256.761C170.928 256.761 170.993 256.697 171.025 256.697L171.315 256.504C171.573 256.343 171.96 256.118 172.444 255.861C173.412 255.347 174.767 254.64 176.284 253.9C177.8 253.161 179.187 252.55 180.187 252.1C180.703 251.875 181.091 251.715 181.381 251.586L181.704 251.457C181.704 251.457 181.768 251.457 181.833 251.457L181.897 251.425Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.445 251.04C180.445 251.04 180.187 251.136 180.026 251.168C179.768 251.232 179.381 251.329 178.897 251.457C177.961 251.715 176.638 252.1 175.251 252.615C173.864 253.129 172.606 253.675 171.734 254.125C171.283 254.35 170.928 254.511 170.702 254.64C170.573 254.704 170.444 254.768 170.315 254.832C170.444 254.736 170.541 254.672 170.67 254.607C170.896 254.479 171.251 254.286 171.702 254.061C173.993 252.904 176.413 252.004 178.897 251.393C179.381 251.265 179.768 251.2 180.026 251.136C180.155 251.104 180.316 251.072 180.445 251.072V251.04Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.254 235.675C194.254 235.675 194.286 235.836 194.318 235.932C194.318 236.125 194.383 236.35 194.383 236.672C194.415 237.507 194.383 238.343 194.189 239.179V239.372L194.06 239.211C193.996 239.115 193.931 239.018 193.866 238.89L192.963 237.25H193.06C192.931 237.7 192.866 238.182 192.866 238.665C192.866 239.018 192.866 239.211 192.866 239.211C192.866 239.179 192.866 239.115 192.866 239.05C192.866 238.922 192.866 238.793 192.866 238.632C192.866 238.15 192.899 237.636 193.028 237.186V237.025L193.124 237.154L194.06 238.761L194.254 239.082H194.125C194.286 238.279 194.35 237.443 194.35 236.64C194.35 236.029 194.286 235.643 194.35 235.643L194.254 235.675Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.413 241.396C177.09 240.914 176.703 240.464 176.316 240.046H176.413C176.38 240.432 176.316 240.946 176.251 241.461C176.251 241.525 176.251 241.589 176.251 241.653V241.878L176.122 241.653C175.767 240.882 175.477 240.207 175.251 239.693C175.122 239.436 175.025 239.146 174.928 238.889C175.09 239.146 175.219 239.403 175.348 239.661C175.574 240.143 175.896 240.818 176.251 241.589H176.122V241.396C176.187 240.882 176.251 240.4 176.283 239.95V239.821L176.38 239.918C176.703 240.207 176.961 240.561 177.187 240.914C177.284 241.043 177.38 241.203 177.413 241.364V241.396Z",
    fill: "#263238"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 272.8C199.428 272.8 211.546 260.726 211.546 245.832C211.546 230.938 199.428 218.864 184.478 218.864C169.529 218.864 157.41 230.938 157.41 245.832C157.41 260.726 169.529 272.8 184.478 272.8Z",
    stroke: "#070707",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 147.475C199.41 147.475 211.514 135.415 211.514 120.539C211.514 105.662 199.41 93.6025 184.478 93.6025C169.547 93.6025 157.443 105.662 157.443 120.539C157.443 135.415 169.547 147.475 184.478 147.475Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_7956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 93,
    width: 55,
    height: 55
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 147.475C199.41 147.475 211.514 135.415 211.514 120.539C211.514 105.662 199.41 93.6025 184.478 93.6025C169.547 93.6025 157.443 105.662 157.443 120.539C157.443 135.415 169.547 147.475 184.478 147.475Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_7956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.22 110.863C177.22 110.863 172.832 107.745 170.09 107.842C167.347 107.938 163.476 108.709 163.766 109.706C164.057 110.702 165.024 112.631 169.025 114.142C173.025 115.652 176.929 112.599 176.929 112.599C176.929 112.599 177.897 112.406 177.22 110.863Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.931 111.538L187.479 111.152C186.995 110.734 186.124 109.995 185.382 109.288C184.22 108.227 183.898 107.167 181.768 107.938C179.639 108.709 178.252 109.706 177.671 109.867C177.09 110.027 172.8 111.795 172.896 114.142C172.993 116.488 173.896 117.645 173.767 118.899C173.638 120.152 170.638 124.331 170.251 124.717C169.864 125.102 168.605 127.063 170.832 128.992C173.09 130.92 175.639 132.303 176.703 131.917C177.768 131.531 179.446 130.342 180.317 130.342C181.188 130.342 184.027 131.595 185.091 134.713C186.156 137.831 186.447 145.578 189.576 149.981C192.705 154.385 197.964 156.506 200.093 156.314C202.223 156.121 205.449 155.06 206.03 154.964C206.61 154.867 220.257 156.539 224.258 156.346C228.258 156.153 235.388 153.389 235.388 153.389C235.388 153.389 240.357 160.396 240.647 161.842C240.938 163.289 239.292 169.91 238.324 172.321C237.582 174.346 236.485 176.21 235.098 177.85C233.937 179.2 232.775 180.003 233.646 180.292C234.517 180.582 238.421 180.582 238.905 180.003C239.389 179.425 240.26 176.982 240.454 176.596C240.647 176.21 241.809 175.824 242.002 174.957C242.196 174.089 241.809 173.96 242.389 172.128C242.97 170.296 246.39 163.192 246.971 162.035C247.551 160.878 247.261 159.303 246.874 156.989C246.487 154.674 246.971 150.174 246.971 150.174C246.971 150.174 251.165 143.585 252.326 140.499C253.488 137.413 254.584 132.913 253.681 129.795C252.778 126.677 243.067 117.645 240.131 116.681C237.195 115.717 234.582 116.199 231.356 117.677C228.129 119.156 214.902 121.085 211.966 120.795C209.03 120.506 207.482 119.252 203.675 118.256C199.868 117.26 198.319 117.838 196.932 118.031C195.544 118.224 193.706 118.224 193.028 117.935C192.351 117.645 191.189 117.067 191.189 117.067C191.189 117.067 197.512 117.742 199.674 115.717C201.836 113.692 204.771 109.995 203.771 109.32C202.771 108.645 199.577 106.395 194.609 108.645C189.64 110.895 188.963 111.281 188.963 111.281L187.898 111.57L187.931 111.538Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.159 148.888C208.74 147.828 210.127 147.056 209.062 144.324C207.998 141.592 205.32 134.938 203.384 133.363C201.448 131.788 201.965 131.113 200.222 131.467C198.48 131.82 197.738 131.949 197.738 131.949C197.738 131.949 196.738 129.795 197.577 128.863C198.416 127.931 201.094 127.963 201.158 125.038C201.223 122.113 200.674 119.895 199.9 119.059C199.61 118.642 199.545 118.127 199.739 117.645C198.835 117.677 197.9 117.806 197.029 117.999C195.674 118.192 193.802 118.192 193.125 117.902C192.447 117.613 191.286 117.034 191.286 117.034C191.286 117.034 197.609 117.709 199.771 115.684C201.932 113.659 204.836 109.963 203.836 109.288C202.836 108.613 199.642 106.363 194.673 108.613C189.705 110.863 189.027 111.249 189.027 111.249L187.963 111.538L187.511 111.152L187.059 110.767C187.156 111.377 187.059 111.988 186.672 112.47C185.769 113.788 181.51 111.731 180.672 113.531C179.833 115.363 174.929 122.338 175.026 123.56C175.122 124.781 175.864 128.027 175.864 128.027C175.864 128.027 174.864 130.085 174.8 131.563C175.606 131.917 176.316 132.045 176.768 131.885C177.832 131.499 179.51 130.342 180.381 130.342C181.252 130.342 184.091 131.595 185.156 134.713C186.221 137.831 186.511 145.578 189.64 149.981C190.124 150.656 190.673 151.267 191.254 151.878C192.963 151.428 194.964 149.756 193.738 144.967C192.415 139.92 195.706 135.26 196.319 135.517C196.932 135.774 196.254 141.817 197.416 144.549C198.577 147.281 202.9 149.692 203.739 148.953C204.255 148.503 204.901 148.149 205.578 147.956C205.578 147.956 207.611 149.949 208.191 148.856L208.159 148.888Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.671 130.47C178.671 130.47 179.349 127.835 174.961 126.002C170.574 124.17 166.573 125.231 165.992 126.677C165.605 127.417 165.799 128.317 166.476 128.799C166.476 128.799 166.089 130.727 167.154 131.531C167.864 132.013 168.702 132.302 169.573 132.335C169.573 132.335 172.219 135.163 174.929 133.974C176.542 133.299 177.865 132.045 178.639 130.47H178.671Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.606 132.335C169.606 132.335 171.445 131.531 171.8 131.724C172.154 131.917 174.219 133.46 175.413 132.977C176.607 132.495 177.381 131.434 176.671 130.277",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.896 128.863C168.395 128.863 168.799 128.446 168.799 127.931C168.799 127.416 168.395 126.999 167.896 126.999C167.397 126.999 166.992 127.416 166.992 127.931C166.992 128.446 167.397 128.863 167.896 128.863Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.348 128.895C172.847 128.895 173.251 128.478 173.251 127.963C173.251 127.448 172.847 127.031 172.348 127.031C171.849 127.031 171.445 127.448 171.445 127.963C171.445 128.478 171.849 128.895 172.348 128.895Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.317 117.227C184.446 117.806 184.091 118.352 183.511 118.481C182.93 118.609 182.381 118.256 182.252 117.677C182.22 117.517 182.22 117.388 182.252 117.227C182.123 116.649 182.478 116.102 183.059 115.974C183.64 115.845 184.188 116.199 184.317 116.777C184.349 116.938 184.349 117.066 184.317 117.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.158 148.953C197.706 151.203 198.384 153.421 199.255 155.607C200.319 158.082 202.836 167.146 202.997 169.139C203.158 171.132 202.255 176.05 201.836 176.532C201.126 177.303 200.481 178.139 199.932 179.007C199.352 180.003 199.029 180.325 199.835 180.325C200.642 180.325 203.933 180.646 204.578 180.164C205.223 179.682 205.578 177.335 205.836 176.757C206.094 176.178 207.095 174.025 207.095 173.093C207.095 172.16 206.998 170.939 207.095 170.103C207.191 169.267 207.772 158.982 207.933 157.31C208.095 155.639 210.676 151.846 211.031 149.499C211.385 147.153 211.514 146.253 211.514 146.253",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.158 148.953C197.706 151.203 198.384 153.421 199.255 155.607C200.319 158.082 202.836 167.146 202.997 169.139C203.158 171.132 202.255 176.05 201.836 176.532C201.126 177.303 200.481 178.139 199.932 179.007C199.352 180.003 199.029 180.325 199.835 180.325C200.642 180.325 203.933 180.646 204.578 180.164C205.223 179.682 205.578 177.335 205.836 176.757C206.094 176.178 207.095 174.025 207.095 173.093C207.095 172.16 206.998 170.939 207.095 170.103C207.191 169.267 207.772 158.982 207.933 157.31C208.095 155.639 210.676 151.846 211.031 149.499C211.385 147.153 211.514 146.253 211.514 146.253",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.936 149.113C232.42 148.535 230.872 144.549 231.033 143.07C231.194 141.592 232.872 145.128 233.872 145.224C234.872 145.321 241.292 140.82 240.615 135.581C239.937 130.342 236.518 129.12 236.937 128.027C237.356 126.935 239.679 126.71 238.26 123.72C236.84 120.731 234.517 119.992 234.517 119.992C234.517 119.992 230.678 120.892 231.517 119.735C232.227 118.738 234.55 117.452 233.582 116.777C232.84 117.034 232.13 117.292 231.42 117.645C228.194 119.092 214.966 121.052 212.03 120.763C210.643 120.602 209.256 120.217 207.998 119.67H207.901C207.901 119.67 209.966 120.988 208.578 124.91C207.191 128.831 206.675 132.463 210.998 134.36C215.321 136.256 215.095 130.374 216.676 130.953C218.257 131.531 219.354 135.838 218.096 137.606C216.838 139.374 214.515 141.592 216.934 144.646C219.354 147.699 231.485 149.724 231.969 149.146L231.936 149.113Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 147.475C199.41 147.475 211.514 135.415 211.514 120.539C211.514 105.662 199.41 93.6025 184.478 93.6025C169.547 93.6025 157.443 105.662 157.443 120.539C157.443 135.415 169.547 147.475 184.478 147.475Z",
    stroke: "#070707",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 210.121C199.41 210.121 211.514 198.061 211.514 183.185C211.514 168.309 199.41 156.249 184.478 156.249C169.547 156.249 157.443 168.309 157.443 183.185C157.443 198.061 169.547 210.121 184.478 210.121Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_7956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 156,
    width: 55,
    height: 55
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 210.121C199.41 210.121 211.514 198.061 211.514 183.185C211.514 168.309 199.41 156.249 184.478 156.249C169.547 156.249 157.443 168.309 157.443 183.185C157.443 198.061 169.547 210.121 184.478 210.121Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_7956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.574 212.5L181.51 212.757C181.51 212.757 179.478 210.796 180.446 210.796C181.414 210.796 182.478 211.664 182.478 211.664C182.478 211.664 180.317 208.353 181.156 208.61C181.994 208.868 183.704 210.7 183.704 210.7C183.704 210.7 182.22 203.853 183.833 204.85C185.446 205.846 185.995 208.032 186.124 208.385C186.253 208.739 187.06 206.81 187.447 207.775C187.769 208.835 187.995 209.96 188.124 211.085C188.124 211.085 189.866 207.678 190.286 208.867C190.705 210.057 190.286 212.05 190.286 212.05C190.286 212.05 192.318 209.96 192.706 210.828C192.964 211.31 192.996 211.889 192.835 212.403H222.032C222.032 212.403 224.064 208 224.871 209.092C225.355 209.735 225.581 210.507 225.549 211.31C225.549 211.31 227.839 207.164 227.968 208.867C228.065 209.8 227.968 210.764 227.71 211.664C227.71 211.664 230.549 210.185 230.388 210.796C230.194 211.375 229.936 211.889 229.581 212.371C229.581 212.371 232.259 211.278 232.13 211.889L232.001 212.5H238.744",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.802 197.939C189.802 197.939 193.222 204.85 193.609 207.228C193.899 208.836 193.77 210.475 193.254 211.986C192.899 213.143 192.802 213.014 192.899 213.143C193.415 213.786 193.673 214.075 194.383 213.689C195.093 213.303 194.867 213.593 195.319 212.596C195.706 211.6 195.996 210.571 196.19 209.543C196.19 209.543 196.545 211.889 196.9 210.7C197.254 209.511 197.609 206.457 197.997 203.5C198.384 200.543 197.997 195.303 197.997 195.303C197.997 195.303 191.157 196.718 189.802 197.907V197.939Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8 176.724C179.8 176.724 176.381 175.02 173.735 174.024C171.09 173.028 167.767 171.613 166.799 170.97C165.831 170.327 165.25 172.513 166.605 175.47C167.96 178.428 169.477 179.778 170.767 180.067C171.993 180.26 173.219 180.388 174.477 180.42C174.477 180.42 175.187 183.024 174.929 184.663C174.671 186.303 172.929 190.867 171.767 192.217C170.606 193.567 167.96 194.371 168.605 196.267C169.251 198.164 171.574 199.771 175.09 200.574C178.607 201.378 183.769 201.571 186.737 200.671C189.157 199.867 191.479 198.903 193.77 197.778C193.77 197.778 202.965 197.778 204.771 198.324C206.578 198.871 212.45 199.771 215.966 199.192C217.773 198.935 219.548 198.549 221.29 198.035C221.29 198.035 222.387 202.085 222.903 204.431C223.419 206.778 222.354 211.085 221.903 212.242C221.451 213.399 219.902 214.139 221.193 214.299C222.483 214.46 223.355 214.042 223.806 213.303C224.258 212.564 224.516 211.149 224.677 211.76C224.839 212.371 225.032 213.303 225.387 212.114C225.742 210.924 225.581 210.764 226.258 208.771C226.936 206.778 226.968 203.917 227.839 202.921C228.71 201.924 233.969 196.717 234.775 191.221C235.582 185.724 236.679 180.163 232.711 173.863C228.742 167.563 218.999 164.317 211.03 164.156C203.062 163.995 191.512 166.117 185.672 169.813C179.833 173.51 179.704 176.692 179.704 176.692L179.8 176.724Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.867 196.042C193.867 196.042 197.577 205.042 197.867 207.485C198.158 209.928 196.867 212.982 196.706 213.882C196.545 214.782 197.964 214.589 198.513 214.235C199.061 213.882 199.771 211.728 199.771 211.728C199.771 211.728 200.481 213.046 200.577 212.178C200.61 211.053 200.739 209.96 200.932 208.835C201.287 206.778 202.255 205.235 203.094 201.539C203.578 199.128 203.675 196.685 203.384 194.242",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.867 196.042C193.867 196.042 197.577 205.042 197.867 207.485C198.158 209.928 196.867 212.982 196.706 213.882C196.545 214.782 197.964 214.589 198.513 214.235C199.061 213.882 199.771 211.728 199.771 211.728C199.771 211.728 200.481 213.046 200.577 212.178C200.61 211.053 200.739 209.96 200.932 208.835C201.287 206.778 202.255 205.235 203.094 201.539C203.578 199.128 203.675 196.685 203.384 194.242",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.381 200.896C178.381 200.896 181.349 199.289 181.478 196.717",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.381 196.846C181.059 196.781 181.769 196.781 182.446 196.846",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.929 194.21C171.929 192.731 169.348 194.274 169.348 194.274L169.057 194.37C168.541 194.82 168.347 195.56 168.573 196.203C169.057 197.681 170.574 198.967 172.864 199.867C173.413 199.706 173.961 199.513 174.477 199.288C176.155 198.549 175.897 195.688 173.897 194.21H173.929Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.122 197.425C170.603 197.425 170.993 197.036 170.993 196.557C170.993 196.078 170.603 195.689 170.122 195.689C169.641 195.689 169.251 196.078 169.251 196.557C169.251 197.036 169.641 197.425 170.122 197.425Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.219 197.199C174.09 197.681 173.606 197.938 173.122 197.81C172.638 197.681 172.38 197.199 172.509 196.717C172.638 196.235 173.122 195.978 173.606 196.106C173.606 196.106 173.606 196.106 173.638 196.106C174.09 196.235 174.348 196.717 174.219 197.167V197.199Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.543 187.171C184.543 187.846 184.156 188.392 183.704 188.392C183.253 188.392 182.833 187.846 182.833 187.171C182.833 186.496 183.22 185.949 183.704 185.949C184.188 185.949 184.543 186.496 184.543 187.171Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.285 182.028C179.51 181.353 178.93 180.453 178.607 179.457C177.962 177.657 179.897 173.574 179.897 173.574C179.897 173.574 180.768 171.517 182.22 172.417C183.672 173.317 188.64 177.046 188.899 180.099C189.157 183.153 185.801 184.085 184.124 183.7L182.446 183.314",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.285 182.028C179.51 181.353 178.93 180.453 178.607 179.457C177.962 177.657 179.897 173.574 179.897 173.574C179.897 173.574 180.768 171.517 182.22 172.417C183.672 173.317 188.64 177.046 188.899 180.099C189.157 183.153 185.801 184.085 184.124 183.7L182.446 183.314",
    stroke: "#263238",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M184.478 210.121C199.41 210.121 211.514 198.061 211.514 183.185C211.514 168.309 199.41 156.249 184.478 156.249C169.547 156.249 157.443 168.309 157.443 183.185C157.443 198.061 169.547 210.121 184.478 210.121Z",
    stroke: "#070707",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_7956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 330,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasySearch);
export default __webpack_public_path__ + "static/media/easy_search.f082fafa754d93c0f4bc9099fcfb454c.svg";
export { ForwardRef as ReactComponent };